import { PDFDownloadLink } from '@react-pdf/renderer';
import Birthday from './Birthday.jsx';
const BirthdayQuotation = ({ pdfData }) => {
  const fileName = "BirthdayQuotation.pdf";
  return (
    <>
      <div className='download-link'>
        <PDFDownloadLink
          document={<Birthday pdfData={pdfData} />}
          fileName={fileName}
        >
          <center>
            <button className='btn btn-success text-white my-3'>
              Download Birthday Quotation
            </button>
          </center>
        </PDFDownloadLink>
      </div>
    </>
  )
}

export default BirthdayQuotation